'use strict'

var promisify = require('./promisify')

module.exports = require('angular')
  .module('promisify', [])
  .service('promisify', promisify)
  .name



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-q-promisify/index.js
// module id = 200
// module chunks = 0